class MembersDatatable {
    constructor(){
        this.organizationID = new URLSearchParams(window.location.search).get('organizationID');
        this.datatable = this.init('#team-members-datatable', this.organizationID);
        this.initActions(this.organizationID);
        this.initFilter();
    }
    init(el, organizationID){
        let thisClass = this;
        const datatable = $(el).DataTable({
            searchDelay: 400,
            processing: true,
            serverSide: true,
            stateSave: false,
            info: true,
            paging: true,
            order: [[1, 'asc']],
            ajax: {
                url: '?do=getTeamMembers',
                type: 'POST',
                data: {
                    organizationID: organizationID
                }
            },
            select: {
                style: 'multi',
                selector: 'td:first-child input[type="checkbox"]',
                className: 'row-selected-light-primary-bg'
            },
            language: {
                emptyTable: "No data found"
            },
            dom:
                "<'table-responsive'tr>" +
                "<'row'" +
                "<'col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start'li>" +
                "<'col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end'p>" +
                ">",
            drawCallback: function(settings) {
                // Remove all visible popovers after datatable draw
                document.querySelectorAll('.popover.fade.show').forEach(function (el) {
                    el.remove();
                });
                // Init all popovers after datatable draw
                const popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'));
                popoverTriggerList.map(function (popoverTriggerEl) {
                    new bootstrap.Popover(popoverTriggerEl);
                });
                // init page length select
                $('select[name=team-members-datatable_length]').select2({minimumResultsForSearch: -1});
                $(el + ' tbody tr').attr('data-cy', 'member');
            },
            columns: [
                {
                    data: 'uuid',
                    title: '<div class="form-check form-check-sm form-check-custom form-check-solid ga-border-primary-200 mx-1">\n' +
                        '       <input class="form-check-input cursor-pointer" type="checkbox" data-kt-check="true" data-kt-check-target="'+el+' .form-check-input" data-kt-check-all="true" value="1"/>\n' +
                        '   </div>',
                    sortable: false,
                    render: function (data, type, row) {
                            return '<div class="form-check form-check-sm form-check-custom form-check-solid ga-border-primary-200 mx-1">'+
                                '    <input class="form-check-input cursor-pointer" type="checkbox" value="'+row['uuid']+'"'+(!row['password'] && !row['isIdp'] ? ' data-invited="true"' : '')+' '+(!row['edit'] ? ' disabled' : '')+' />'+
                                '</div>';
                    }
                },
                {
                    data: 'member',
                    title: 'Member',
                    sortable: true,
                    className: 'min-w-120px',
                    render: function (data, type, row) {
                        return new MemberInfoGenerator(row).generateTableMember();
                    }
                },
                {
                    data: 'accessCards',
                    title: 'Access cards',
                    className: 'min-w-100px',
                    sortable: false,
                    render: function (data, type, row) {
                        let html = '';
                        for (let i = 0; i < row['accessCards'].length; i++) {
                            if(row['edit']){
                                html += '<span class="badge badge-danger me-1 mb-1 cursor-pointer text-hover-white bg-hover-danger edit-access-card" data-cy="member-ac-card" id="'+row['accessCards'][i]['uuid']+'">'+row['accessCards'][i]['name']+'</span>';
                            } else {
                                html += '<span class="badge badge-danger me-1 mb-1">'+row['accessCards'][i]['name']+'</span>';
                            }
                        }
                        return html;
                    }
                },
                {
                    data: 'groupsArr',
                    title: 'Groups',
                    sortable: false,
                    render: function (data, type, row) {
                        let html = '<div class="symbol-group symbol-hover flex-nowrap">';
                        for(let i = 0; i < row['groupsArr'].length; i++){
                            if (i < 3) {
                                html += new GroupInfoGenerator().generateMemberIconView(row['groupsArr'][i]['name'], row['groupsArr'][i]['edit'], row['groupsArr'][i]['uuid'], row['groupsArr'][i]['numberOfMembers']);
                            } else {
                                html += '<div class="symbol symbol-40px symbol-circle border ga-border-primary-300" id="'+row['uuid']+'" data-bs-toggle="popover" data-bs-placement="top" data-bs-trigger="hover" data-bs-html="true" data-bs-content="<div class=\'fw-bold\'>'+(row['groupsArr'].length - 3)+' more Groups</div>">' +
                                    '        <div class="symbol-label bg-light-primary border border-2 border-white text-primary fs-6 fw-bolder '+ (row['edit'] ? 'edit-member' : '') +'">+'+(row['groupsArr'].length - 3)+'</div>'+
                                    '     </div>';
                                break;
                            }
                        }
                        return html+'</div>';
                    }
                },
                {
                    data: 'devices',
                    title: 'Devices',
                    sortable: false,
                    render: function (data, type, row) {
                        let html = '<div class="symbol-group symbol-hover flex-nowrap">';
                        for (let i = 0; i < row['devices'].length; i++) {
                            if (i < 3) {
                                html += `<div class="symbol symbol-40px symbol-circle border ga-border-primary-300" id="` + row['devices'][i]['uuid'] + `">` +
                                    (row['devices'][i]['edit'] && row['devices'][i]['name'] ? '<span class="edit-device">' : '') +
                                    `        <div class="symbol-label bg-light-primary border border-2 border-white `+(row['devices'][i]['isBlocked'] ? ' filter-grayscale' : '')+`" data-bs-toggle="popover" data-bs-placement="top" data-bs-trigger="hover" data-bs-html="true" data-bs-content="<div class='fw-bold text-center'>` + row['devices'][i]['name'] + `</div><div class='text-center'>` + row['devices'][i]['osNameWithVersion'] + `</div>">` +
                                    '             <img alt="avatar" class="h-40px" src="/media/goodaccess/icons/os/' + row['devices'][i]['osName'] + '.svg"/>' +
                                    '        </div>' +
                                    (row['devices'][i]['isBlocked'] ? '<span class="symbol-badge badge badge-circle bg-danger start-85 top-85 w-15px h-15px fs-10 text-center text-white" data-bs-toggle="popover" data-bs-placement="top" data-bs-trigger="hover" data-bs-html="true" data-bs-content="<div class=\'fw-bold\'>blocked</div>">&#10005;</span>' : '') +
                                    (row['devices'][i]['edit'] ? '</span>' : '') +
                                    '     </div>';
                            } else {
                                html += '<div class="symbol symbol-40px symbol-circle border ga-border-primary-300" id="'+row['uuid']+'" data-bs-toggle="popover" data-bs-placement="top" data-bs-trigger="hover" data-bs-html="true" data-bs-content="<div class=\'fw-bold\'>'+(row['devices'].length - 3)+' more devices</div>">' +
                                    '        <div class="symbol-label bg-light-primary border border-2 border-white text-primary fs-6 fw-bolder '+ (row['edit'] ? 'edit-member' : '') +'">+'+(row['devices'].length - 3)+'</div>'+
                                    '     </div>';
                                break;
                            }
                        }
                        return html+'</div>';
                    }
                },
                {
                    data: null,
                    title: 'Action',
                    sortable: false,
                    render: function (data, type, row) {
                        let html = '<div class="datatable-action min-w-3" id="'+row['uuid']+'">';
                        let editHtml = '';
                        if (row['edit']) {
                            if(!row['password'] && row['isIdp'] === 0){
                                editHtml += '<div class="btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-2 resend-invitation" data-cy="resend-invitation-action" data-bs-toggle="popover" data-bs-placement="top" data-bs-trigger="hover" data-bs-content="Resend invitation">' +
                                    '           <span class="svg-icon svg-icon-3">' +
                                    '               <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">'+
                                    '                   <path opacity="0.3" d="M21 19H3C2.4 19 2 18.6 2 18V6C2 5.4 2.4 5 3 5H21C21.6 5 22 5.4 22 6V18C22 18.6 21.6 19 21 19Z" fill="currentColor"/>'+
                                    '                   <path d="M21 5H2.99999C2.69999 5 2.49999 5.10005 2.29999 5.30005L11.2 13.3C11.7 13.7 12.4 13.7 12.8 13.3L21.7 5.30005C21.5 5.10005 21.3 5 21 5Z" fill="currentColor"/>'+
                                    '               </svg>' +
                                    '           </span>' +
                                    '       </div>';
                                if(!row['isIdentityBlocked']){
                                    editHtml += '<div class="btn btn-icon btn-bg-light btn-sm me-2 cursor-not-allowed" data-cy="block-member-btn" data-bs-toggle="popover" data-bs-placement="top" data-bs-trigger="hover" data-bs-content="Invited member cannot be blocked.">'+
                                        '           <span class="svg-icon svg-icon-3">' +
                                        '               <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">'+
                                        '                   <rect opacity="0.3" x="2" y="2" width="20" height="20" rx="10" fill="currentColor"/>'+
                                        '                   <rect x="7" y="15.3137" width="12" height="2" rx="1" transform="rotate(-45 7 15.3137)" fill="currentColor"/>'+
                                        '                   <rect x="8.41422" y="7" width="12" height="2" rx="1" transform="rotate(45 8.41422 7)" fill="currentColor"/>'+
                                        '               </svg>' +
                                        '           </span>' +
                                        '        </div>';
                                }
                            } else {
                                editHtml += '<div class="btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-2 edit-member" data-cy="edit-member-btn" data-bs-toggle="popover" data-bs-placement="top" data-bs-trigger="hover" data-bs-content="Edit">' +
                                    '           <span class="svg-icon svg-icon-3">' +
                                    '               <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">' +
                                    '                   <path opacity="0.3" d="M21.4 8.35303L19.241 10.511L13.485 4.755L15.643 2.59595C16.0248 2.21423 16.5426 1.99988 17.0825 1.99988C17.6224 1.99988 18.1402 2.21423 18.522 2.59595L21.4 5.474C21.7817 5.85581 21.9962 6.37355 21.9962 6.91345C21.9962 7.45335 21.7817 7.97122 21.4 8.35303ZM3.68699 21.932L9.88699 19.865L4.13099 14.109L2.06399 20.309C1.98815 20.5354 1.97703 20.7787 2.03189 21.0111C2.08674 21.2436 2.2054 21.4561 2.37449 21.6248C2.54359 21.7934 2.75641 21.9115 2.989 21.9658C3.22158 22.0201 3.4647 22.0084 3.69099 21.932H3.68699Z" fill="currentColor"></path>\n' +
                                    '                   <path d="M5.574 21.3L3.692 21.928C3.46591 22.0032 3.22334 22.0141 2.99144 21.9594C2.75954 21.9046 2.54744 21.7864 2.3789 21.6179C2.21036 21.4495 2.09202 21.2375 2.03711 21.0056C1.9822 20.7737 1.99289 20.5312 2.06799 20.3051L2.696 18.422L5.574 21.3ZM4.13499 14.105L9.891 19.861L19.245 10.507L13.489 4.75098L4.13499 14.105Z" fill="currentColor"></path>\n' +
                                    '               </svg>' +
                                    '           </span>' +
                                    '       </div>';
                                if(row['isBlocked'] && !row['isIdentityBlocked']){
                                    editHtml += '<div class="btn btn-icon btn-bg-light btn-sm me-2 btn-active-color-primary unblock-member cursor-pointer" data-cy="unblock-member-btn" data-bs-toggle="popover" data-bs-placement="top" data-bs-trigger="hover" data-bs-html="true" data-bs-content="Unblock">'+
                                        '           <span class="svg-icon svg-icon-3">' +
                                        '               <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">'+
                                        '                   <rect opacity="0.3" x="2" y="2" width="20" height="20" rx="10" fill="currentColor"/>'+
                                        '                   <path d="M10.4343 12.4343L8.75 10.75C8.33579 10.3358 7.66421 10.3358 7.25 10.75C6.83579 11.1642 6.83579 11.8358 7.25 12.25L10.2929 15.2929C10.6834 15.6834 11.3166 15.6834 11.7071 15.2929L17.25 9.75C17.6642 9.33579 17.6642 8.66421 17.25 8.25C16.8358 7.83579 16.1642 7.83579 15.75 8.25L11.5657 12.4343C11.2533 12.7467 10.7467 12.7467 10.4343 12.4343Z" fill="currentColor"/>'+
                                        '               </svg>' +
                                        '           </span>' +
                                        '        </div>';
                                } else if(!row['isIdentityBlocked']) {
                                    editHtml += '<div class="btn btn-icon btn-bg-light btn-sm me-2 btn-active-color-primary block-member cursor-pointer" data-cy="block-member-btn" data-bs-toggle="popover" data-bs-placement="top" data-bs-trigger="hover" data-bs-html="true" data-bs-content="Block">'+
                                        '           <span class="svg-icon svg-icon-3">' +
                                        '               <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">'+
                                        '                   <rect opacity="0.3" x="2" y="2" width="20" height="20" rx="10" fill="currentColor"/>'+
                                        '                   <rect x="7" y="15.3137" width="12" height="2" rx="1" transform="rotate(-45 7 15.3137)" fill="currentColor"/>'+
                                        '                   <rect x="8.41422" y="7" width="12" height="2" rx="1" transform="rotate(45 8.41422 7)" fill="currentColor"/>'+
                                        '               </svg>' +
                                        '           </span>' +
                                        '        </div>';
                                }
                            }
                            html += editHtml + '<div class="btn btn-icon btn-bg-light btn-sm btn-active-color-primary delete-member cursor-pointer" data-cy="thrash-can-member-btn" data-bs-toggle="popover" data-bs-placement="top" data-bs-trigger="hover" data-bs-html="true" data-bs-content="Delete">'+
                                '                   <span class="svg-icon svg-icon-3">' +
                                '                       <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">' +
                                '                           <path d="M5 9C5 8.44772 5.44772 8 6 8H18C18.5523 8 19 8.44772 19 9V18C19 19.6569 17.6569 21 16 21H8C6.34315 21 5 19.6569 5 18V9Z" fill="currentColor"></path>' +
                                '                           <path opacity="0.5" d="M5 5C5 4.44772 5.44772 4 6 4H18C18.5523 4 19 4.44772 19 5V5C19 5.55228 18.5523 6 18 6H6C5.44772 6 5 5.55228 5 5V5Z" fill="currentColor"></path>' +
                                '                           <path opacity="0.5" d="M9 4C9 3.44772 9.44772 3 10 3H14C14.5523 3 15 3.44772 15 4V4H9V4Z" fill="currentColor"></path>' +
                                '                       </svg>' +
                                '                   </span>' +
                                '               </div>';
                        }
                        return html+'</div>';
                    }
                }
            ]
        }).on('init.dt', function () {
            if(datatable.page.info().recordsTotal === 0){
                $('#team-members-datatable_wrapper').hide();
                $('#team-members-datatable_no-results').addClass('d-flex flex-center flex-column').removeClass('d-none');
            }
        }).on('select', function () {
            let selectedRows = thisClass.datatable.rows({selected:true}).count();
            let displayedRows = thisClass.datatable.rows({page:'current'}).count();
            if(selectedRows === displayedRows){
                $('#team-members-datatable_wrapper [data-kt-check-all]').prop('checked', true);
            }
        }).on('deselect', function () {
            let selectedRows = thisClass.datatable.rows({selected:true}).count();
            let displayedRows = thisClass.datatable.rows({page:'current'}).count();
            if(selectedRows !== displayedRows){
                $('#team-members-datatable_wrapper [data-kt-check-all]').prop('checked', false);
            }
        }).on('draw', function () {
            thisClass.removeSelectedRows(organizationID);
            $('#team-members-datatable_wrapper [data-kt-check-all]').prop('checked', false);
            if(datatable.page.info().recordsTotal !== 0){
                $('#team-members-datatable_wrapper').show();
                $('#members_tab [data-kt-docs-table-filter=search]').parent().show();
            }
            const container = document.querySelector('#members_tab');
            const baseToolbar = container.querySelector('[data-kt-docs-table-toolbar="base"]');
            const selectedToolbar = container.querySelector('[data-kt-docs-table-toolbar="selected"]');
            if(selectedToolbar){
                selectedToolbar.classList.add('d-none');
            }
            if(baseToolbar){
                baseToolbar.classList.remove('d-none');
            }
        });
        // Add delay to datatable search
        new DatatableSearchDelay(datatable, '#members_tab [data-kt-docs-table-filter=search]');
        return datatable;
    }
    removeSelectedRows(organizationID){
        const thisClass = this;
        // Toggle selected action toolbar
        // Select all checkboxes
        const container = document.querySelector('#members_tab');
        const checkboxes = container.querySelectorAll('[type="checkbox"]');

        // Select elements
        const deleteSelected = container.querySelector('[data-kt-docs-table-select="delete_selected"]');
        const blockSelected = container.querySelector('[data-kt-docs-table-select="block_selected"]');
        const inviteSelected = container.querySelector('[data-kt-docs-table-select="invite_selected"]');
        const unblockSelected = container.querySelector('[data-kt-docs-table-select="unblock_selected"]');

        // Toggle delete selected toolbar
        checkboxes.forEach(c => {
            // Checkbox on click event
            c.addEventListener('click', async function () {
                setTimeout(function () {
                    thisClass.toggleToolbars();
                }, 50);
            });
        });

        // Deleted selected rows
        if(deleteSelected) {
            deleteSelected.addEventListener('click', function () {
                let vpnUserIDs = thisClass.getSelectedIDs();
                let html = `
                    <span class="text-center text-primary">Are you sure you want to delete selected Members?</span>
                    <div class="text-center text-primary mt-5"><b>Please note:</b> Deleting these Members will also delete all records (logs) related to their activities.</div>
                    <div class="form-check mt-5">
                        <input class="form-check-input float-none corsor-pointer" name="agreeSwalCheckbox" type="checkbox" value="" id="agreeSwalCheckbox" />
                        <label class="form-check-label text-primary corsor-pointer" for="agreeSwalCheckbox">
                            I agree
                        </label>
                    </div>`;
                Swal.fire({
                    html: html,
                    icon: "warning",
                    iconColor: "#FF5206",
                    buttonsStyling: false,
                    reverseButtons: true,
                    showCancelButton: true,
                    confirmButtonText: "Yes, delete!",
                    customClass: {
                        confirmButton: "btn btn-danger mt-0 cy-member-delete-confirm-btn",
                        cancelButton: 'btn btn-light-primary mt-0 cy-member-delete-cancel-btn',
                    },
                    showLoaderOnConfirm: true,
                    returnFocus: false,
                    preConfirm: () => {
                        let swalCheckbox = document.querySelector('input[name="agreeSwalCheckbox"]');
                        if(swalCheckbox && !swalCheckbox.checked){
                            Swal.showValidationMessage(`You need to agree`);
                            return;
                        }

                        return fetch('/team-members?do=removeTeamMember&organizationID='+organizationID+'&vpnUserIDs='+vpnUserIDs)
                            .then(response => {
                                if (!response.ok) {
                                    throw new Error(response.statusText)
                                }
                                return response.json();
                            }).catch(error => {
                                console.log(error);
                                Swal.showValidationMessage(`Request failed: ${error}`)
                            });
                    },
                    allowOutsideClick: () => !Swal.isLoading(),
                    allowEscapeKey: () => !Swal.isLoading()
                }).then((result) => {
                    if (result.isConfirmed) {
                        const headerCheckbox = container.querySelectorAll('[type="checkbox"]')[0];
                        headerCheckbox.checked = false;
                        container.querySelector('[data-kt-docs-table-toolbar="base"]').classList.remove('d-none');
                        container.querySelector('[data-kt-docs-table-toolbar="selected"]').classList.add('d-none');
                        if(result.value === 'deleted') {
                            toastr.success('Members have been deleted.');

                            let numberOfMembersElement = $(".members-tab-menu .number-of-members");
                            if(numberOfMembersElement){
                                numberOfMembersElement.text(numberOfMembersElement.text() - vpnUserIDs.length);
                                if(numberOfMembersElement.parent().hasClass('badge-light-danger')){
                                    numberOfMembersElement.parent().removeClass('badge-light-danger');
                                    numberOfMembersElement.parent().addClass('badge-light-primary');
                                }
                            }

                            thisClass.datatable.ajax.reload(null, false);
                            $('#groups-datatable').DataTable().ajax.reload(null, false);
                            thisClass.redrawAddMemberSnippet();
                        } else {
                            thisClass.fireAdminBlockedSwal(result.value);
                        }
                    }
                });
            });
        }

        if(inviteSelected){
            inviteSelected.addEventListener('click', function () {
                let vpnUserIDs = thisClass.getSelectedIDs();
                Swal.fire({
                    html: `<span class="text-center text-primary">Are you sure you want to resend invitation to selected members?</span>`,
                    icon: "warning",
                    iconColor: "#FF5206",
                    buttonsStyling: false,
                    reverseButtons: true,
                    showCancelButton: true,
                    confirmButtonText: "Yes, resend!",
                    customClass: {
                        confirmButton: "btn btn-danger mt-0",
                        cancelButton: 'btn btn-light-primary mt-0',
                    },
                    showLoaderOnConfirm: true,
                    returnFocus: false,
                    preConfirm: () => {
                        return fetch('/team-members?do=resendInvitation&organizationID='+organizationID+'&vpnUserIDs='+vpnUserIDs)
                            .then(response => {
                                if (!response.ok) {
                                    throw new Error(response.statusText)
                                }
                                return response.json();
                            }).catch(error => {
                                Swal.showValidationMessage(`Request failed: ${error}`)
                            });
                    },
                    allowOutsideClick: () => !Swal.isLoading(),
                    allowEscapeKey: () => !Swal.isLoading()
                }).then((result) => {
                    if (result.isConfirmed) {
                        const headerCheckbox = container.querySelectorAll('[type="checkbox"]')[0];
                        headerCheckbox.checked = false;
                        container.querySelector('[data-kt-docs-table-toolbar="base"]').classList.remove('d-none');
                        container.querySelector('[data-kt-docs-table-toolbar="selected"]').classList.add('d-none');
                        if(result.value === 'invited') {
                            toastr.success('Members have been invited.');
                            thisClass.datatable.ajax.reload(null, false);
                            $('#groups-datatable').DataTable().ajax.reload(null, false);
                            thisClass.redrawAddMemberSnippet();
                        }
                    }
                });
            });
        }

        if(blockSelected) {
            blockSelected.addEventListener('click', function () {
                let vpnUserIDs = thisClass.getSelectedIDs();
                Swal.fire({
                    html: `<span class="text-center text-primary">Are you sure you want to block selected members?</span>`,
                    icon: "warning",
                    iconColor: "#FF5206",
                    buttonsStyling: false,
                    reverseButtons: true,
                    showCancelButton: true,
                    confirmButtonText: "Yes, block!",
                    customClass: {
                        confirmButton: "btn btn-danger mt-0 cy-member-block-confirm-btn",
                        cancelButton: 'btn btn-light-primary mt-0 cy-member-block-cancel-btn',
                    },
                    showLoaderOnConfirm: true,
                    returnFocus: false,
                    preConfirm: () => {
                        return fetch('/team-members?do=blockTeamMember&organizationID='+organizationID+'&vpnUserIDs='+vpnUserIDs)
                            .then(response => {
                                if (!response.ok) {
                                    throw new Error(response.statusText)
                                }
                                return response.json();
                            }).catch(error => {
                                Swal.showValidationMessage(`Request failed: ${error}`)
                            });
                    },
                    allowOutsideClick: () => !Swal.isLoading(),
                    allowEscapeKey: () => !Swal.isLoading()
                }).then((result) => {
                    if (result.isConfirmed) {
                        const headerCheckbox = container.querySelectorAll('[type="checkbox"]')[0];
                        headerCheckbox.checked = false;
                        container.querySelector('[data-kt-docs-table-toolbar="base"]').classList.remove('d-none');
                        container.querySelector('[data-kt-docs-table-toolbar="selected"]').classList.add('d-none');
                        if(result.value === 'blocked'){
                            toastr.success('Members have been successfully blocked!');
                            thisClass.datatable.ajax.reload(null, false);
                            $('#groups-datatable').DataTable().ajax.reload(null, false);
                        } else {
                            thisClass.fireAdminBlockedSwal(result.value);
                        }
                    }
                });
            });
        }

        if(unblockSelected) {
            unblockSelected.addEventListener('click', function () {
                let vpnUserIDs = thisClass.getSelectedIDs();
                Swal.fire({
                    html: `<span class="text-center text-primary">Are you sure you want to unblock selected members?</span>`,
                    icon: "warning",
                    iconColor: "#FF5206",
                    buttonsStyling: false,
                    reverseButtons: true,
                    showCancelButton: true,
                    confirmButtonText: "Yes, unblock!",
                    customClass: {
                        confirmButton: "btn btn-danger mt-0",
                        cancelButton: 'btn btn-light-primary mt-0',
                    },
                    showLoaderOnConfirm: true,
                    returnFocus: false,
                    preConfirm: () => {
                        return fetch('/team-members?do=unblockTeamMember&organizationID='+organizationID+'&vpnUserIDs='+vpnUserIDs)
                            .then(response => {
                                if (!response.ok) {
                                    throw new Error(response.statusText)
                                }
                                return response.json();
                            }).catch(error => {
                                Swal.showValidationMessage(`Request failed: ${error}`)
                            });
                    },
                    allowOutsideClick: () => !Swal.isLoading(),
                    allowEscapeKey: () => !Swal.isLoading()
                }).then((result) => {
                    if (result.isConfirmed) {
                        const headerCheckbox = container.querySelectorAll('[type="checkbox"]')[0];
                        headerCheckbox.checked = false;
                        container.querySelector('[data-kt-docs-table-toolbar="base"]').classList.remove('d-none');
                        container.querySelector('[data-kt-docs-table-toolbar="selected"]').classList.add('d-none');
                        if(result.value === 'unblocked'){
                            toastr.success('Members have been successfully unblocked!');
                            thisClass.datatable.ajax.reload(null, false);
                            $('#groups-datatable').DataTable().ajax.reload(null, false);
                        } else {
                            thisClass.fireAdminBlockedSwal(result.value);
                        }
                    }
                });
            });
        }
    }
    toggleToolbars() {
        // Define variables
        const container = document.querySelector('#members_tab');
        const toolbarSelected = container.querySelector('[data-kt-docs-table-toolbar="selected"]');
        if(toolbarSelected){
            const selectedCount = container.querySelector('[data-kt-docs-table-select="selected_count"]');
            // Select refreshed checkbox DOM elements
            const allCheckboxes = container.querySelectorAll('tbody [type="checkbox"]');

            // Detect checkboxes state & count
            let checkedState = false;
            let hideInvitedBtn = false;
            let count = 0;

            // Count checked boxes
            allCheckboxes.forEach(c => {
                if (c.checked) {
                    if(!c.attributes['data-invited']){
                        hideInvitedBtn = true;
                    }
                    checkedState = true;
                    count++;
                }
            });

            // Toggle toolbars
            if (checkedState) {
                selectedCount.innerHTML = count;
                toolbarSelected.classList.remove('d-none');
            } else {
                toolbarSelected.classList.add('d-none');
            }

            const inviteSelected = container.querySelector('[data-kt-docs-table-select="invite_selected"]');
            if(hideInvitedBtn){
                inviteSelected.classList.add('d-none');
            } else {
                inviteSelected.classList.remove('d-none');
            }
        }
    }
    getSelectedIDs(){
        // Define variables
        const container = document.querySelector('#team-members-datatable_wrapper');
        // Select refreshed checkbox DOM elements
        const allCheckboxes = container.querySelectorAll('tbody [type="checkbox"]');

        let ids = [];

        // Count checked boxes
        allCheckboxes.forEach(c => {
            if (c.checked) {
                ids.push(c.value);
            }
        });
        return ids;
    }
    initActions(organizationID){
        const thisClass = this;

        /** Select All rows */
        $(document).on('click','#members-datatable [data-kt-check-all]',function(e){
            if ($(this).is(':checked')) {
                thisClass.datatable.rows().select();
            } else {
                thisClass.datatable.rows().deselect();
            }
        });

        $(document).on('click', '.unblock-member', function(e) {
            let vpnUserID = $(this).parent()[0].id;
            let memberName = '';
            memberName = $(this).closest('tr').find('span[data-member-name]').attr('data-member-name');
            if(memberName === undefined){
                memberName = $(this).closest('tr').find('span[data-member-username]').attr('data-member-username');
            }
            Swal.fire({
                html: `<span class="text-center text-primary">Member `+(memberName !== undefined ? `<b>`+memberName+`</b> ` : ``)+`is going to be unblocked!</span>`,
                icon: "warning",
                iconColor: "#FF5206",
                buttonsStyling: false,
                reverseButtons: true,
                showCancelButton: true,
                confirmButtonText: "Yes, unblock!",
                customClass: {
                    confirmButton: "btn btn-danger mt-0 cy-member-unblock-confirm-btn",
                    cancelButton: 'btn btn-light-primary mt-0 cy-member-unblock-cancel-btn',
                },
                showLoaderOnConfirm: true,
                returnFocus: false,
                preConfirm: () => {
                    return fetch('/team-members?do=unblockTeamMember&organizationID='+organizationID+'&vpnUserID='+vpnUserID)
                        .then(response => {
                            if (!response.ok) {
                                throw new Error(response.statusText)
                            }
                            return response.json();
                        }).catch(error => {
                            Swal.showValidationMessage(`Request failed: ${error}`)
                        });
                },
                allowOutsideClick: () => !Swal.isLoading(),
                allowEscapeKey: () => !Swal.isLoading()
            }).then((result) => {
                if (result.isConfirmed) {
                    if(result.value === 'unblocked'){
                        toastr.success('Member has been successfully unblocked!');
                        thisClass.datatable.ajax.reload(null, false);
                    } else {
                        thisClass.fireAdminBlockedSwal(result.value);
                    }
                }
            });
        });
        $(document).on('click', '.block-member', function(e) {
            let vpnUserID = $(this).parent()[0].id;
            let memberName = '';
            memberName = $(this).closest('tr').find('span[data-member-name]').attr('data-member-name');
            if(memberName === undefined){
                memberName = $(this).closest('tr').find('span[data-member-username]').attr('data-member-username');
            }
            Swal.fire({
                html: `<span class="text-center text-primary">Member `+(memberName !== undefined ? `<b>`+memberName+`</b> ` : ``)+`is going to be blocked!</span>`,
                icon: "warning",
                iconColor: "#FF5206",
                buttonsStyling: false,
                reverseButtons: true,
                showCancelButton: true,
                confirmButtonText: "Yes, block!",
                customClass: {
                    confirmButton: "btn btn-danger mt-0 cy-member-block-confirm-btn",
                    cancelButton: 'btn btn-light-primary mt-0 cy-member-block-cancel-btn',
                },
                showLoaderOnConfirm: true,
                returnFocus: false,
                preConfirm: () => {
                    return fetch('/team-members?do=blockTeamMember&organizationID='+organizationID+'&vpnUserID='+vpnUserID)
                        .then(response => {
                            if (!response.ok) {
                                throw new Error(response.statusText)
                            }
                            return response.json();
                        }).catch(error => {
                            Swal.showValidationMessage(`Request failed: ${error}`)
                        });
                },
                allowOutsideClick: () => !Swal.isLoading(),
                allowEscapeKey: () => !Swal.isLoading()
            }).then((result) => {
                if (result.isConfirmed) {
                    if(result.value === 'blocked'){
                        toastr.success('Member has been successfully blocked!');
                        thisClass.datatable.ajax.reload(null, false);
                    }  else {
                        thisClass.fireAdminBlockedSwal(result.value);
                    }
                }
            });
        });
        $(document).on('click','#team-members-datatable .delete-member',function(e){
            let vpnUserID = $(this).parent()[0].id;
            let memberName = '';
            memberName = $(this).closest('tr').find('span[data-member-name]').attr('data-member-name');
            if(memberName === undefined){
                memberName = $(this).closest('tr').find('span[data-member-username]').attr('data-member-username');
            }

            let html = `
                <span class="text-center text-primary">Member `+(memberName !== undefined ? `<b>`+memberName+`</b> ` : ``)+`is going to be completely deleted!</span>
                <div class="text-center text-primary mt-5"><b>Please note:</b> Deleting this Member will also delete all records (logs) related to their activities.</div>
                <div class="form-check mt-5">
                    <input class="form-check-input float-none corsor-pointer" name="agreeSwalCheckbox" type="checkbox" value="" id="agreeSwalCheckbox" />
                    <label class="form-check-label text-primary corsor-pointer" for="agreeSwalCheckbox">
                        I agree
                    </label>
                </div>`;
            Swal.fire({
                html: html,
                icon: "warning",
                iconColor: "#FF5206",
                buttonsStyling: false,
                reverseButtons: true,
                showCancelButton: true,
                confirmButtonText: "Yes, delete!",
                customClass: {
                    confirmButton: "btn btn-danger mt-0 cy-member-delete-confirm-btn",
                    cancelButton: 'btn btn-light-primary mt-0 cy-member-delete-cancel-btn',
                },
                showLoaderOnConfirm: true,
                returnFocus: false,
                preConfirm: () => {
                    let swalCheckbox = document.querySelector('input[name="agreeSwalCheckbox"]');
                    if(swalCheckbox && !swalCheckbox.checked){
                        Swal.showValidationMessage(`You need to agree`);
                        return;
                    }

                    return fetch('/team-members?do=removeTeamMember&organizationID='+organizationID+'&vpnUserID='+vpnUserID)
                        .then(response => {
                            if (!response.ok) {
                                throw new Error(response.statusText)
                            }
                            return response.json();
                        }).catch(error => {
                            Swal.showValidationMessage(`Request failed: ${error}`)
                        });
                },
                allowOutsideClick: () => !Swal.isLoading(),
                allowEscapeKey: () => !Swal.isLoading()
            }).then((result) => {
                if (result.isConfirmed) {
                    if(result.value === 'deleted') {
                        toastr.success('Member has been deleted.');
                        let editTeamMemberModal = document.getElementById('edit_team_member_modal');
                        if(editTeamMemberModal){
                            bootstrap.Modal.getOrCreateInstance(editTeamMemberModal).hide();
                        }

                        let numberOfMembersElement = $(".members-tab-menu .number-of-members");
                        numberOfMembersElement.text(thisClass.datatable.page.info().recordsTotal);
                        if(numberOfMembersElement.parent().hasClass('badge-light-danger')){
                            numberOfMembersElement.parent().removeClass('badge-light-danger');
                            numberOfMembersElement.parent().addClass('badge-light-primary');
                        }

                        thisClass.datatable.ajax.reload(null, false);
                        $('#groups-datatable').DataTable().ajax.reload(null, false);
                        thisClass.redrawAddMemberSnippet();
                    } else {
                        thisClass.fireAdminBlockedSwal(result.value);
                    }
                }
            });
        });
        $(document).on('click', '.resend-invitation', function(e) {
            let vpnUserID = $(this).parent()[0].id;
            let memberName = $(this).closest('tr').find('span[data-member-username]').attr('data-member-username');
            Swal.fire({
                html: `<span class="text-center text-primary">Resend invitation to `+(memberName !== undefined ? `<b>`+memberName+`</b>` : `this Member`)+`?</span>`,
                icon: "question",
                iconColor: "#FF5206",
                buttonsStyling: false,
                reverseButtons: true,
                showCancelButton: true,
                confirmButtonText: "Yes, send!",
                customClass: {
                    confirmButton: "btn btn-danger mt-0",
                    cancelButton: 'btn btn-light-primary mt-0',
                },
                showLoaderOnConfirm: true,
                returnFocus: false,
                preConfirm: () => {
                    return fetch('/team-members?do=resendInvitation&organizationID='+organizationID+'&vpnUserID='+vpnUserID)
                        .then(response => {
                            if (!response.ok) {
                                throw new Error(response.statusText)
                            }
                            return response.json();
                        }).catch(error => {
                            Swal.showValidationMessage(`Request failed: ${error}`)
                        });
                },
                allowOutsideClick: () => !Swal.isLoading(),
                allowEscapeKey: () => !Swal.isLoading()
            }).then((result) => {
                if (result.isConfirmed) {
                    if(result.value) {
                        toastr.success('Invitation has been sent.');
                    }
                }
            });
        });
    }
    fireAdminBlockedSwal(names) {
        Swal.fire({
            html: `<span class="text-center text-primary"><b>`+names+`</b> has been blocked due to violating Acceptable Usage Policy. For this reason, we have restricted actions associated with your Members. If you wish to continue, please contact our support team.</span>`,
            icon: "warning",
            iconColor: "#FF5206",
            buttonsStyling: false,
            reverseButtons: true,
            showCancelButton: true,
            confirmButtonText: '<a href="https://www.goodaccess.com/contact" target="_blank" class="text-white">\n' +
                '                  <i class="text-white fa-solid fa-arrow-up-right-from-square"></i> Contact us\n' +
                '               </a>',
            customClass: {
                confirmButton: "btn btn-danger mt-0",
                cancelButton: 'btn btn-light-primary mt-0',
            },
        });
    }
    redrawAddMemberSnippet(){
        const thisClass = this;
        naja.makeRequest('GET', '?do=redrawAddMemberSnippet', {
            'organizationID': thisClass.organizationID
        }, {
            history: false // Prevent URL changes in browser history
        }).then((response) => {
            if (response) {
                new Members(response.vpnUsernames, response.memberGroups, true);
            }
        });
    }
    initFilter(){
        const thisClass = this;
        this.initFilterSelect2();

        // Apply
        const applyFilterButton = document.querySelector('[data-table-filter-action="members-datatable-apply"]');
        if(applyFilterButton) {
            applyFilterButton.addEventListener('click', function () {
                thisClass.applyFilter();
            });
        }

        // Reset
        const resetFilterButton = document.querySelector('[data-table-filter-action="members-datatable-reset"]');
        if(resetFilterButton){
            resetFilterButton.addEventListener('click', function () {
                // Reset inputs
                $('[data-table-filter="members-datatable-status"]').val([]).trigger('change');
                $('[data-table-filter="members-datatable-idp"]').val([]).trigger('change');
                $('[data-table-filter="members-datatable-access-card"]').val([]).trigger('change');
                $('[data-table-filter="members-datatable-group"]').val([]).trigger('change');

                $('input[data-table-filter="without-groups"]').prop("checked", false);
                $('input[data-table-filter="without-access-cards"]').prop("checked", false);

                thisClass.applyFilter(true);
            });
        }
    }
    initFilterSelect2(){
        const optionImgFormat = (item) => {
            if (!item.id) {
                return item.text;
            }
            const span = document.createElement('span');
            span.innerHTML =
                '<div class="d-flex align-items-center" style="max-width:150px;">'+
                '   <img src="'+item.element.getAttribute('data-icon')+'" alt="avatar" class="ms-1 h-15px">'+
                '   <span class="fs-6 fw-semibold text-primary ms-2">' + item.text + '</span>'+
                '</div>';
            return $(span);
        }

        const optionTextFormat = (item) => {
            if (!item.id) {
                return item.text;
            }
            const span = document.createElement('span');
            span.innerHTML =
                '<div class="d-flex align-items-center" style="max-width:150px;">'+
                '   <span class="fs-6 fw-semibold ms-2">' + item.text + '</span>'+
                '</div>';
            return $(span);
        }

        const initSelect2 = (element, optionFormat) => {
            if(element){
                $(element).select2({
                    placeholder: "Select an option",
                    templateSelection: optionFormat,
                    templateResult: optionFormat,
                    minimumResultsForSearch: -1,
                    dropdownParent: $('#membersFilterMenu'),
                    allowClear: true,
                }).on('select2:select', function (e) {
                    KTMenu.updateDropdowns()
                });

                // Prevent menu from closing when deselecting an item from select2
                const menuEl = document.querySelector("#membersFilterMenu");
                if (menuEl) {
                    const menu = KTMenu.getInstance(menuEl);
                    if (menu) {
                        $(element).on('select2:unselect', function (e) {
                            element.setAttribute("data-multiple-unselect", "1");
                        });
                        $(element).on('select2:clear', function (e) {
                            $(element).val([]).trigger("change");
                        });
                        menu.on("kt.menu.dropdown.hide", function(item) {
                            if (element.getAttribute("data-multiple-unselect") === "1") {
                                element.removeAttribute("data-multiple-unselect");
                                return false;
                            }
                        });
                    }
                }
            }
        };

        // Init Select2
        const idpSelectEl = document.querySelector('[data-table-filter="members-datatable-idp"]');
        const accessCardSelectEl = document.querySelector('[data-table-filter="members-datatable-access-card"]');
        const groupSelectEl = document.querySelector('[data-table-filter="members-datatable-group"]');

        initSelect2(idpSelectEl, optionImgFormat);
        initSelect2(accessCardSelectEl, optionTextFormat);
        initSelect2(groupSelectEl, optionTextFormat);
    }
    applyFilter(reset = false){
        const thisClass = this;
        let numberOfActiveFilters = 0;
        let numberOfActiveFiltersEl = document.getElementById('membersDatatableNumberOfActiveFilters');

        if(reset){
            this.datatable.columns().search('');
        } else {
            let status = $('[data-table-filter="members-datatable-status"]').select2('data');
            let statusArr = [];
            for(const i in status){
                if(status[i].id !== ''){
                    statusArr.push(status[i].id);
                }
            }

            let idps = $('[data-table-filter="members-datatable-idp"]').select2('data');
            let idpsArr = [];
            for(const i in idps){
                if(idps[i].id !== ''){
                    idpsArr.push(idps[i].id);
                }
            }

            let accessCards = $('[data-table-filter="members-datatable-access-card"]').select2('data');
            let withoutAccessCards = document.querySelector('input[data-table-filter="without-access-cards"]');
            let accessCardArr = [];
            for(const i in accessCards){
                if(accessCards[i].id !== ''){
                    accessCardArr.push(accessCards[i].id);
                }
            }
            if(withoutAccessCards && withoutAccessCards.checked){
                accessCardArr.push('without-access-cards');
            }

            let groups = $('[data-table-filter="members-datatable-group"]').select2('data');
            let withoutGroups = document.querySelector('input[data-table-filter="without-groups"]');
            let groupArr = [];
            for(const i in groups){
                if(groups[i].id !== ''){
                    groupArr.push(groups[i].id);
                }
            }
            if(withoutGroups && withoutGroups.checked){
                groupArr.push('without-groups');
            }

            thisClass.datatable.column(1).search(JSON.stringify(statusArr));
            numberOfActiveFilters += statusArr.length;
            thisClass.datatable.column(2).search(JSON.stringify(accessCardArr));
            numberOfActiveFilters += accessCardArr.length;
            thisClass.datatable.column(3).search(JSON.stringify(groupArr));
            numberOfActiveFilters += groupArr.length;
            thisClass.datatable.column(4).search(JSON.stringify(idpsArr));
            numberOfActiveFilters += idpsArr.length;
        }
        numberOfActiveFiltersEl.innerText = numberOfActiveFilters;
        thisClass.datatable.draw();
    }
}
window.MembersDatatable = MembersDatatable;